import { Div, Line, MultilineInput, RefString, Span } from "@tblabs/truffle";
import { Center } from "../../Components/Utils/Center";
import { CenteredLoader } from "../../Components/Utils/CenteredLoader";
import { OrdersManager } from "../../Services/OrdersManager";
import { CustomerStepsPrinter } from "../../Services/StepsPrinter";
import { OrderEventsCalendar } from "../../Components/OrderEventsCalendar";
import { Order } from "../../Models/Order";
import { InfoFrame } from "../../Components/Utils/InfoFrame";
import { Tabs } from "../../Components/Utils/Tabs";
import { RemoteStorageChatConnector } from "../../Chat/Storage/RemoteStorageChatConnector";
import { Chat } from "../../Chat/Services/Chat";
import { ChatUser } from "../../Chat/Models/ChatUser";
import { ChatView } from "../../Chat/Components/ChatView";
import { MessageBus } from "../../Services/MessageBus/MessageBus";
import { FatalError } from "../../Components/FatalError";
import { BigHeader } from "../../Components/Utils/SmallHeader";


export class CustomerOrderViewPage extends Div
{
    private CHAT_VISIBLE = false;
    private loader = new CenteredLoader("Pobieranie zamówienia... Proszę czekać");

    constructor(private _manager: OrdersManager, private _messageBus: MessageBus, private orderId: string)
    {
        super();
        this.TextAlignCenter().PaddingBottom(32)

        this.Append(
            this.loader
        );
    }

    protected async OnAppend(): Promise<void>
    {
        const order: Order | null = await this._manager.GetOne(this.orderId);

        this.loader.RemoveSelf();

        if (!order)
        {
            this.Append(
                new Center(new FatalError(`Nie znaleziono zamówienia 😥\n\n\nSkontaktuj się z obsługą sklepu podając ten numer:\n\n${this.orderId.slice(-5).toUpperCase()}`)));
            return;
        }

        if (order.IsClosed)
        {
            this.Append(
                new Center("Zamówienie jest już zamknięte. Jeśli chcesz je przywrócić, skontaktuj się z obsługą sklepu.").MarginTop(32)
            )
            return;
        }

        const view = new RefString("🐾 Przebieg zamówienia").Storable("customer-order-view");

        const tabs = new Tabs(view);
        tabs.Add("🐾 Przebieg zamówienia", () => new CustomerStepsPrinter(order))
            .Add("📅 Widok kalendarza", () => new Center(new OrderEventsCalendar(order)).MarginTopBottom(32))

        if (order.Notes.Public.value)
            tabs.Add("📝 Notatka", () => new Center(new MultilineInput(order.Notes.Public).Readonly().Rows(20).MarginTop(16).Padding(12).BorderRadius(8)))

        if (this.CHAT_VISIBLE)
        {
            const _connector = new RemoteStorageChatConnector(this._messageBus, order.Id);
            const chat = new Chat(_connector, new ChatUser({ Name: `Klient #${order.ShortId}` }));
            await _connector.Load();

            tabs.Add(`💬 Czat${chat.IsUnread ? "🔴" : ""}`, () => new ChatView(chat));
        }

        this.Append(
            new Div().TextAlignLeft().MarginBottom(16).Padding(16).Append(
                new Span("Zamówienie #" + order.ShortId)
                    .FontSize(24).Bold().Color("#1e87f0")
                    .Margin(0)
                    .MarginTop(0).MarginBottom(16),
                "\n",
                new Span(order.CurrentStep?.GetStateName() || "Zamknięte")
                    .FontSize(16).Color("#888")
                    .Margin(0)
                    .MarginTop(0).MarginBottom(16),
            ),
            tabs,
            new Line(),
            new InfoFrame("Chcesz coś zmienić w zamówieniu?",
                "Zadzwoń lub napisz:\n☎️ 507-293-714"
            ),
        )
    }
}
